import { render, staticRenderFns } from "./BankDetailsForm.vue?vue&type=template&id=51f63ab1&scoped=true&"
import script from "./BankDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./BankDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./BankDetailsForm.vue?vue&type=style&index=0&id=51f63ab1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f63ab1",
  null
  
)

export default component.exports